import { TotalFileDownloadSupplierDTO } from '../dtos';

export type VilmaVersion = 'VILMA_27' | 'VILMA_28';
export const vilmaVersion = ['VILMA_27', 'VILMA_28'] as const;

export interface TotalFileDownloadSupplierProps {
  mgSupplierId: number;
  mgSupplierName?: string;
  finfoSupplierId?: number;
  lastDownload: string;
  priceChangedStockItems: number;
  priceChangedNonStockItems: number;
  changedItems: number;
}

export class TotalFileDownloadSupplier {
  mgSupplierId: number;
  mgSupplierName?: string;
  finfoSupplierId?: number;
  lastDownload: string;
  priceChangedStockItems: number;
  priceChangedNonStockItems: number;
  changedItems: number;

  constructor({
    mgSupplierId,
    mgSupplierName,
    finfoSupplierId,
    lastDownload,
    priceChangedStockItems,
    priceChangedNonStockItems,
    changedItems,
  }: TotalFileDownloadSupplierProps) {
    this.mgSupplierId = mgSupplierId;
    this.mgSupplierName = mgSupplierName;
    this.finfoSupplierId = finfoSupplierId;
    this.lastDownload = lastDownload;
    this.priceChangedStockItems = priceChangedStockItems;
    this.priceChangedNonStockItems = priceChangedNonStockItems;
    this.changedItems = changedItems;
  }

  static fromDto(dto: TotalFileDownloadSupplierDTO): TotalFileDownloadSupplier {
    return new TotalFileDownloadSupplier({
      mgSupplierId: dto.mgSupplierId,
      mgSupplierName: dto.mgSupplierName,
      finfoSupplierId: dto.finfoSupplierId,
      lastDownload: dto.lastDownload,
      priceChangedStockItems: dto.priceChangedStockItems,
      priceChangedNonStockItems: dto.priceChangedNonStockItems,
      changedItems: dto.changedItems,
    });
  }
}
